import { useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import slickLogo from 'assets/images/logos/slick-logo-text-white.png';
import { FormCard } from 'components/onboarding/FormCard.component';
import { OnboardingLayout } from 'components/onboarding/OnboardingLayout.component';
import { QuickSetupType } from 'components/onboarding/quickSetupType/QuickSetupType.component';
import LINK from 'constants/link.const';
import QST from 'constants/quickSetupType.const';
import { useTranslation } from 'providers/GILT.provider';
import fromObjectToQueryString from 'utils/converters/object/fromObjectToQueryString.util';
import { fromPropsToQuery } from 'utils/converters/props/path.util';
import navFor from 'utils/links/navFor.util';
import { getGtmPagePath, pushToDataLayer } from 'utils/tracking';

import { StepIndicator } from '../StepIndicator.component';

import CN from './QuickSetupTypeWrap.module.scss';

export const QuickSetupTypeWrap = () => {
  const [activeSalonType, setActiveSalonType] = useState(0);
  const [isFooterButtonActive, setIsFooterButtonActive] = useState(false);

  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleOptionClick = useCallback((newActive) => {
    setActiveSalonType(newActive);
    setIsFooterButtonActive(newActive !== 0);
  }, []);

  const onFooterButtonClicked = useCallback(() => {
    if (!isFooterButtonActive) {
      return;
    }

    const quickSetupTypeMap = { 1: QST.hair, 2: QST.beauty };

    const state = { salonType: quickSetupTypeMap[activeSalonType] };

    const routerProps = { location, history };

    pushToDataLayer('signup_step2_submit', { step_number: 2, page_path: getGtmPagePath() });

    navFor('QuickSetupTypeWrap.onFooterButtonClicked()', routerProps).push({
      pathname: LINK.onboardingSalon,
      state,
      search: fromObjectToQueryString({ ...fromPropsToQuery(routerProps), ...state }),
    });
  }, [activeSalonType, history, isFooterButtonActive, location]);

  return (
    <OnboardingLayout mobileHeader={<img src={slickLogo} alt="Slick logo" className={CN.logo} />}>
      <FormCard
        header={<h2 className={CN.title}>{t('register.quickSetup.title')}</h2>}
        submitButtonLabel={t('register.quickSetup.submitButton')}
        onSubmit={onFooterButtonClicked}
        isSubmitDisabled={!isFooterButtonActive}
      >
        <StepIndicator currentStep={2} />
        <QuickSetupType onOptionClick={handleOptionClick} activeSalonType={activeSalonType} />
      </FormCard>
    </OnboardingLayout>
  );
};
